import { FC } from 'react';
import Button from '@components/DesignLibrary/Button';
import Spacer from '@components/Spacer';
import * as ApiModels from '@typings/api-models';
import ArrowLeft from '@components/Icons/ArrowLeft';
import ListCell from '@components/DesignLibrary/ListCell';
import s from './AdditionalTermsInfo.module.scss';

type PersonBasic = Pick<ApiModels.Person, 'id' | 'name' | 'email'> & {
  color?: string | null;
  logo?: string | null;
  source?: string | null;
};

type Props = {
  primaryUser: PersonBasic | null;
  secondaryUser: PersonBasic | null;
  onConfirm: () => void;
  onBack: () => void;
  additionalFields: { label: string, key: string }[];
  fieldsData: Record<string, string | number | null | undefined>;
  signatureData?: { key: string; type: ApiModels.CustomTermsDynamicVariableType; }[];
};

const ReviewPage: FC<Props> = ({ primaryUser, secondaryUser, onConfirm, onBack, additionalFields, fieldsData, signatureData }) => (
  <div className={s.container}>
    <button className={s.backButton} onClick={onBack} aria-label="Back">
      <ArrowLeft size={24} />
    </button>
    <p className='body-sm-bold' style={{ textAlign: 'center' }}>Review</p>
    <Spacer size={20} />

    {/* Additional fields preview */}
    {additionalFields.map(field => (
      <div key={field.key} className={s.reviewSection}>
        <div className={s.previewLabel}>{field.label}</div>
        <div className={s.previewValue}>{fieldsData[field.key]}</div>
      </div>
    ))}

    <Spacer size={16} />

    <div className={s.reviewSection}>
      <p className='body-sm-bold'>{(signatureData && signatureData[0]?.key) ? signatureData[0].key?.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase() : 'primary user'}</p>
      <Spacer size={8} />
      <div className={s.userInfo}>
        {primaryUser && (
          <ListCell
            label={primaryUser.name ?? ''}
            bottomLine={primaryUser.email ?? ''}
            avatar={{
              color: primaryUser.color ?? '',
              name: primaryUser.name ?? '',
              url: primaryUser.logo ?? '',
            }}
            isSelected={false}
            showCheckbox={false}
          />
        )}
      </div>
    </div>

    <Spacer size={16} />

    <div className={s.reviewSection}>
      <p className='body-sm-bold'>{(signatureData && signatureData[1]?.key) ? signatureData[1].key?.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase() : 'secondary user'}</p>
      <Spacer size={8} />
      <div className={s.userInfo}>
        {secondaryUser && (
          <ListCell
            label={secondaryUser.name || ''}
            bottomLine={secondaryUser.email || ''}
            avatar={{
              color: secondaryUser.color || '',
              name: secondaryUser.name || '',
              url: secondaryUser.logo ?? '',
            }}
            isSelected={false}
            showCheckbox={false}
          />
        )}
      </div>
    </div>

    <Spacer size={32} />

    <div className={s.buttonGroup}>
      <Button
        variant="primary"
        size="md"
        fullWidth
        onClick={onConfirm}
      >
          Confirm
      </Button>
    </div>
  </div>
);

export default ReviewPage;
